<template>
  <footer class="modern-footer">
    <div class="footer-content">
      
      <!-- Logo y Descripción -->
      <div class="footer-brand">
        <div class="image-footer">
          <img class="footer-logo footer-logo-light" src="/img/logos/logo_blocks_rojo_azul.png" alt="ASW Blocks">
          <img class="footer-logo footer-logo-dark" src="/img/logos/logo_blocks_blanco.png" alt="ASW Blocks">
        </div>
        <p class="footer-description">Programador de clases para American School Way</p>
        <p class="footer-version">Versión {{ packageVersion }}</p>
      </div>

      <!-- Enlaces -->
      <div class="footer-links">
        <a 
          target="_blank" 
          href="https://www.americanschoolway.edu.co/danos-tu-opinion"
          class="footer-link"
        >
          <i class="ri-question-answer-line"></i>
          Danos tu opinión y PQRSF
        </a>
      </div>

      <!-- Bandera Colombia -->
      <div class="footer-divider">
        <div class="colombia-flag">
          <div class="flag-yellow"></div>
          <div class="flag-blue"></div>
          <div class="flag-red"></div>
        </div>
      </div>

      <!-- Copyright -->
      <div class="footer-copyright">
        <p>&copy; 2018 - {{ new Date().getFullYear() }} American School Way. Todos los derechos reservados.</p>
      </div>

    </div>

    <!-- Barra de Redes Sociales Fija -->
    <div class="social-bar-fixed">
      <div class="social-bar-content">
        <a href="https://www.instagram.com/americanschoolway/?hl=es-la" class="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
          <i class="ri-instagram-fill"></i>
        </a>
        <a href="https://www.tiktok.com/@americanschoolway" class="social-icon" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
          <i class="ri-tiktok-fill"></i>
        </a>
        <a href="https://www.youtube.com/@americanschoolwaycol" class="social-icon" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
          <i class="ri-youtube-fill"></i>
        </a>
        <a href="https://open.spotify.com/show/30UscQPBbnlodJqh6ACCmu" class="social-icon" aria-label="Spotify" target="_blank" rel="noopener noreferrer">
          <i class="ri-spotify-fill"></i>
        </a>
        <a href="https://whatsapp.com/channel/0029Va9jXHH9cDDUYZUYRm3O" class="social-icon" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
          <i class="ri-whatsapp-fill"></i>
        </a>
        <a href="https://login.pearson.com/v1/piapi/iesui/signin?client_id=bWPoUiRnLpUhX2rhGeP4AaLCeyQYNYDA&redirect_uri=https%3A%2F%2Fenglish-dashboard.pearson.com%2Flogin&nonce=123454321&prompt=login&login_success_url=https%3A%2F%2Fenglish-dashboard.pearson.com%2Flogin%3FiesCode%3DDa8ieXtPEE" class="social-icon" aria-label="MyEnglishLab" target="_blank" rel="noopener noreferrer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="currentColor" font-family="Arial, sans-serif" font-weight="700" font-size="8" letter-spacing="-0.5">MEL</text>
          </svg>
        </a>
        <a href="https://americanschoolway.edu.co/" class="social-icon" aria-label="Sitio Web" target="_blank" rel="noopener noreferrer">
          <i class="ri-global-line"></i>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState({
      packageVersion: state => state.packageVersion
    })
  }
}
</script>

<style scoped>
/* Footer styles */
.modern-footer {
  padding: 3rem 0 2rem;
  background: var(--theme-bg-secondary);
  border-top: 1px solid var(--theme-border-color);
  margin-top: auto;
  flex-shrink: 0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.footer-brand {
  text-align: center;
}

.image-footer {
  border-radius: 12px;
  margin: 0 auto;
  width: fit-content;
  padding: 12px;
  justify-content: center;
  align-items: center;
  display: flex;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  box-shadow: var(--theme-shadow-sm);
}

.footer-logo {
  width: 200px;
  max-width: 90%;
  height: auto;
  transition: all 0.3s ease;
}

/* Logo claro (rojo/azul) visible solo en tema claro; logo blanco solo en tema oscuro */
.footer-logo-dark {
  display: none;
}

html:not(.light-theme) .footer-logo-light {
  display: none;
}

html:not(.light-theme) .footer-logo-dark {
  display: block;
}

.footer-description {
  margin: 0.75rem 0 0.5rem;
  font-size: 1rem;
  color: var(--theme-text-secondary);
  font-weight: 500;
}

.footer-version {
  margin: 0;
  font-size: 0.875rem;
  color: var(--theme-text-muted);
  font-weight: 400;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}

.footer-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  color: var(--theme-text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.footer-link:hover {
  background: var(--theme-hover-bg);
  color: var(--theme-text-primary);
  transform: translateY(-2px);
  text-decoration: none;
  box-shadow: var(--theme-shadow-md);
}

.footer-link svg {
  flex-shrink: 0;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.footer-link:hover svg {
  opacity: 1;
  transform: scale(1.1);
}

.footer-divider {
  width: 100%;
  display: flex;
  justify-content: center;
}

.colombia-flag {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: var(--theme-shadow-sm);
}

.flag-yellow {
  width: 50px;
  height: 12px;
  background: linear-gradient(135deg, #FCD116 0%, #FFE000 100%);
}

.flag-blue {
  width: 50px;
  height: 6px;
  background: linear-gradient(135deg, #003893 0%, #0051D5 100%);
}

.flag-red {
  width: 50px;
  height: 6px;
  background: linear-gradient(135deg, #CE1126 0%, #E63946 100%);
}

.footer-copyright {
  text-align: center;
  color: var(--theme-text-muted);
  font-size: 0.85rem;
}

.footer-copyright p {
  margin: 0;
}

/* Responsive Footer */
@media (max-width: 768px) {
  .modern-footer {
    padding: 2rem 0 1.5rem;
  }

  .footer-logo {
    width: 160px;
  }

  .footer-description {
    font-size: 0.95rem;
  }

  .footer-version {
    font-size: 0.8rem;
  }

  .footer-links {
    gap: 1rem;
  }

  .footer-link {
    padding: 0.625rem 1rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .footer-logo {
    width: 140px;
  }

  .footer-link {
    width: 100%;
    justify-content: center;
  }

  .colombia-flag {
    transform: scale(0.9);
  }
}

/* Barra de Redes Sociales Fija */
.social-bar-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Tema oscuro para la barra */
html.light-theme .social-bar-fixed {
  background: rgba(255, 255, 255, -0.15);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

html:not(.light-theme) .social-bar-fixed {
  background: rgba(23, 25, 35, -0.15);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.social-bar-content {
  max-width: 550px;
  margin: 0 auto;
  padding: 8px 1rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 0.5rem;
}

.social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 12px;
  background: var(--theme-bg-card);
  color: var(--theme-text-secondary);
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--theme-border-color-strong);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
}

.social-icon::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: var(--theme-gradient-primary);
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  opacity: 0.1;
  z-index: 0;
}

.social-icon:hover::before {
  width: 100%;
  height: 100%;
}

.social-icon svg {
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: var(--app-primary-blue);
  color: var(--app-primary-blue);
}

.social-icon:active {
  transform: translateY(-2px);
}

/* Colores específicos por red social al hover */
.social-icon:nth-child(1):hover {
  color: #E4405F; /* Instagram */
  border-color: rgba(228, 64, 95, 0.3);
}

.social-icon:nth-child(2):hover {
  color: #000000; /* TikTok */
  border-color: rgba(0, 0, 0, 0.3);
}

html:not(.light-theme) .social-icon:nth-child(2):hover {
  color: #69C9D0; /* TikTok cyan en modo oscuro */
  border-color: rgba(105, 201, 208, 0.3);
}

.social-icon:nth-child(3):hover {
  color: #FF0000; /* YouTube */
  border-color: rgba(255, 0, 0, 0.3);
}

.social-icon:nth-child(4):hover {
  color: #1DB954; /* Spotify */
  border-color: rgba(29, 185, 84, 0.3);
}

.social-icon:nth-child(5):hover {
  color: #25D366; /* WhatsApp */
  border-color: rgba(37, 211, 102, 0.3);
}

.social-icon:nth-child(6):hover {
  color: #0F75BC; /* MyEnglishLab - azul educativo */
  border-color: rgba(15, 117, 188, 0.3);
}

.social-icon:nth-child(7):hover {
  color: #0D4E8C; /* Sitio Web - azul corporativo */
  border-color: rgba(13, 78, 140, 0.3);
}

/* Responsive para la barra social */
@media (max-width: 480px) {

  .social-icon svg {
    width: 18px;
    height: 18px;
  }
}

/* Ajuste del padding del footer para evitar que la barra tape contenido */
.modern-footer {
  padding-bottom: calc(2rem + 60px); /* Espacio extra para la barra fija */
}

@media (max-width: 768px) {
  .modern-footer {
    padding-bottom: calc(1.5rem + 56px);
  }
}
</style>
